import {toFragment} from '@freckle/educator-entities/ts/common/helpers/routers/query-params'
import type {RlDomainT} from '@freckle/educator-entities/ts/common/models/rl-domain'
import type {RlStandardSetT} from '@freckle/educator-entities/ts/common/models/rl-standard-set'
import type {SchoolAttrs} from '@freckle/educator-entities/ts/roster/models/school'
import type {BaseTeacherAttrs} from '@freckle/educator-entities/ts/users/models/teacher'
import {Link} from '@freckle/educator-materials/ts/components/link'
import {H1} from '@freckle/educator-materials/ts/components/typography'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {Routes} from '@freckle/school/ts/common/routers/routes'
import {ProficiencyReportStudentBucket as StudentBucket} from '@freckle/school/ts/proficiency-report/components/student-bucket'
import {getProficiencyReportTableDataFromCollection} from '@freckle/school/ts/proficiency-report/logic/proficiency-report-table-logic'
import {StudentCategories} from '@freckle/school/ts/proficiency-report/logic/proficiency-report-table-logic'
import type {ProficiencyReportAttrs} from '@freckle/school/ts/proficiency-report/models/proficiency-report'
import type {StudentsMapT} from '@freckle/school/ts/users/collections/students'

type Props = {
  students: StudentsMapT
  schools: Array<SchoolAttrs>
  proficiencyReportData: Array<ProficiencyReportAttrs>
  teacher: BaseTeacherAttrs
  domain: RlDomainT
  selectedSchoolsIds: Array<number>
  selectedGrade: number
  mathStandardSet: RlStandardSetT
}

export function TeacherProficiencyReport(props: Props) {
  const {
    students,
    proficiencyReportData,
    teacher,
    domain,
    selectedSchoolsIds,
    selectedGrade,
    mathStandardSet,
    schools
  } = props
  const {t} = useSafeTranslation()

  const bucketData = getProficiencyReportTableDataFromCollection(proficiencyReportData, schools)[0]

  const buckets =
    bucketData !== undefined ? (
      StudentCategories.all().map((category, i: number) => (
        <StudentBucket
          students={students}
          bucketData={bucketData}
          category={category}
          mathStandardSet={mathStandardSet}
          key={i}
        />
      ))
    ) : (
      <></>
    )

  const params = {
    domainId: domain.id,
    grade: selectedGrade,
    schoolsIds: selectedSchoolsIds
  }

  const mainReportUrl = toFragment(Routes.schoolProficiencyReport(), params)

  return (
    <div className="proficiency-report-container">
      <Link className="back-link" href={mainReportUrl} reactRouter>
        {t('TEACHER_PROFICIENCY_REPORT_BACK')}
      </Link>
      <H1>
        {t('TEACHER_PROFICIENCY_REPORT_H1_TITLE', {
          domainName: domain.name,
          teacherFirstName: teacher.firstName,
          teacherLastName: teacher.lastName
        })}
      </H1>
      <div className="proficiency-report-student-buckets-wrapper">{buckets}</div>
    </div>
  )
}
